import * as Yup from 'yup'

import { formValidationSchemaNoChanged } from '../../../../Form'
import { toUserSelectItem } from '../../../../User'

import { APPLICANT_RESPONSIBLE_MANAGER_FIELD_NAME } from './ApplicantResponsibleManagerModal.constants'

function isApplicantResponsibleManagerEqual({ initialValues, values }) {
  return (
    getApplicantResponsibleManagerPayload(initialValues)[
      APPLICANT_RESPONSIBLE_MANAGER_FIELD_NAME
    ] ===
    getApplicantResponsibleManagerPayload(values)[
      APPLICANT_RESPONSIBLE_MANAGER_FIELD_NAME
    ]
  )
}

function toApplicantResponsibleManagerSelectItem(user) {
  return user
    ? toUserSelectItem({
        archived: user.is_archived,
        avatar_color: user.avatar_color,
        company_post_name: user.job_title,
        email: user.email,
        fullname: user.full_name,
        id: user.id,
      })
    : null
}

export function getApplicantResponsibleManagerInitialValues(
  responsibleManager
) {
  return {
    [APPLICANT_RESPONSIBLE_MANAGER_FIELD_NAME]:
      toApplicantResponsibleManagerSelectItem(responsibleManager),
  }
}

export function getApplicantResponsibleManagerPayload(values) {
  return {
    [APPLICANT_RESPONSIBLE_MANAGER_FIELD_NAME]:
      values[APPLICANT_RESPONSIBLE_MANAGER_FIELD_NAME]?.value ?? null,
  }
}

export function getApplicantResponsibleManagerValidationSchema({
  initialValues,
}) {
  return Yup.object({
    [APPLICANT_RESPONSIBLE_MANAGER_FIELD_NAME]: Yup.object().nullable(),
  }).concat(
    formValidationSchemaNoChanged({
      initialValues,
      isEqual: isApplicantResponsibleManagerEqual,
    })
  )
}
